import { render, staticRenderFns } from "./PacientesDetallePlanesTratamiento.vue?vue&type=template&id=6311194f&scoped=true&"
import script from "./PacientesDetallePlanesTratamiento.vue?vue&type=script&lang=js&"
export * from "./PacientesDetallePlanesTratamiento.vue?vue&type=script&lang=js&"
import style0 from "./PacientesDetallePlanesTratamiento.vue?vue&type=style&index=0&id=6311194f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311194f",
  null
  
)

export default component.exports